import { Routes } from '@angular/router';
import { HomeComponent } from './shared/home/home.component';
import { NotFoundComponent } from './shared/not-found/not-found.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
export const routes: Routes = [
    {path:'',component:HomeComponent,
        data: {
            title: 'AI-First Software Development Company | India & USA',
            description: 'Kalpita Technologies is an AI-first software development company in Bengaluru & Austin. 130+ engineers, 70%+ AI-enabled delivery, SOC 2 & ISO certified.',
            ogTitle: 'Kalpita Technologies — AI-First Software Development Company',
            ogDescription: '8+ years. 130+ engineers. 70%+ AI-enabled engineering. Custom software, AI solutions, and proprietary AI products for enterprises in the USA and India.',
            url: 'https://www.kalpitatechnologies.com/'
        }
    },
    {path: 'aboutcompany', loadChildren: () => import('./modules/aboutcompany/aboutcompany-routing.module').then(m => m.ABOUTCOMPANY_ROUTES)},
    {path:'news-letters',loadChildren: () => import('./modules/news-letters/news-letters-routing.module').then(m => m.NEWSLETTER_ROUTES)},
    {path:'company-services',loadChildren: () => import('./modules/company-services/company-services-routing.module').then(m => m.COMPANY_SERVICES_ROUTES)},
    {path:'industries',loadChildren: () => import('./modules/industries/industries-routing.module').then(m => m.INDUSTRIES_ROUTES)},
    {path:'tech-blogs',loadChildren: () => import('./modules/blog/blog-routing.module').then(m => m.BLOG_ROUTES)},
    {path:'kalpita-case-studies',loadChildren: () => import('./modules/case-studies/case-studies-routing.module').then(m => m.caseStudiesRoutes)},
    {path:'kalpita-white-papers',loadChildren: () => import('./modules/whitepaper/whitepaper-routing.module').then(m => m.whitepaper_routes)},
    {path:'kalpita-tech-geek',loadChildren: () => import('./modules/techgeek/techgeek-routing.module').then(m => m.techgeek_routes)},
    {path:'kalpita-press-release',loadChildren: () => import('./modules/in-the-news/in-the-news-routing.module').then(m => m.inthenews_routes)},
    {path:'careers',loadChildren: () => import('./modules/careers/careers-routing.module').then(m => m.Careers_Routes)},
    {path:'gallery',loadChildren: () => import('./modules/gallery-page/gallery-page-routing.module').then(m => m.GalleryPage_Routes)},
    {path: 'aboutcompany/legal', loadChildren: () => import('./modules/aboutcompany/legal/legal-routing.module').then(m => m.LEGAL_ROUTES)},

    // /contact-us is restored as a real, crawlable, prerendered URL. 6.0 had
    // replaced it with a modal (contact-modal.service.ts), which removed the
    // URL entirely: Search Console measured 106 clicks / 20,100 impressions at
    // average position 4.00 on /contact-us before it began returning 404, and
    // it is still hard-linked from the live Terms of Use page and referenced as
    // the ContactAction target in 8 blog JSON-LD graphs. Restoring the original
    // path preserves that signal with no redirect hop. The modal stays in place
    // for in-page CTAs; this route is the addressable version of the same form.
    // ContactUsComponent injects NgbActiveModal, which only exists inside an
    // ng-bootstrap modal. Providing it at the route level gives the routed
    // instance its own no-op NgbActiveModal (the base class methods are empty),
    // so the component renders as a page AND the existing modal path is
    // completely untouched. Without this, prerendering /contact-us throws
    // NullInjectorError and emits a page with no <title> and no canonical.
    {
        path: 'contact-us',
        loadComponent: () => import('./shared/contact-us/contact-us.component').then(m => m.ContactUsComponent),
        providers: [NgbActiveModal],
        data: {
            title: 'Contact Kalpita Technologies | Talk to Our Engineering Team',
            description: 'Contact Kalpita Technologies - offices in Bengaluru, India and Austin, Texas. Talk to our team about custom software, AI solutions and enterprise engineering.',
            url: 'https://www.kalpitatechnologies.com/contact-us'
        }
    },

    // The nine Kalpita product pages live under /products/*, matching the
    // canonical URLs declared in their JSON-LD. They surface in the "Solutions"
    // mega menu. The three legacy root-level URLs (/kalpita-nexa,
    // /kalpita-ai-interview, /kalpita-recruit) were indexed before this move and
    // 301 to their new paths via LEGACY_REDIRECTS in server.js; the client-side
    // fallbacks below only matter for in-app navigation to an old path.
    {path: 'products', loadChildren: () => import('./modules/products/products-routing.module').then(m => m.PRODUCTS_ROUTES)},
    {path: 'kalpita-nexa', redirectTo: 'products/kalpita-nexa', pathMatch: 'full'},
    {path: 'kalpita-ai-interview', redirectTo: 'products/kalpita-ai-interview', pathMatch: 'full'},
    {path: 'kalpita-recruit', redirectTo: 'products/kalpita-recruit', pathMatch: 'full'},
    // /csat is a real, reachable, crawlable page (HTTP 200) that is deliberately
    // NOT indexed. Business decision: the client-satisfaction survey is sent to
    // clients directly and has no search-landing value, but it must keep working
    // for the people who receive the link. `robots` renders
    // <meta name="robots" content="noindex, follow"> into the prerendered HTML,
    // and server.js sends the matching X-Robots-Tag header — belt and braces, so
    // the directive survives even if a CDN strips response headers. It is kept
    // OUT of sitemap.xml and is NOT Disallow'd in robots.txt, because a blocked
    // crawl would prevent Google from ever reading the noindex.
    {path: 'csat', loadComponent: () => import('./shared/csat/csat.component').then(m => m.CsatComponent),
        data: {
            title: 'Client Satisfaction Survey - CSAT | Kalpita Technologies',
            description: 'Kalpita Technologies values your experience and feedback! Complete our CSAT survey to help improve software solutions, AI innovations, and client experience.',
            keywords: 'Client Satisfaction Survey, CSAT Survey, Customer Feedback, Client Experience, Customer Survey, Service Quality Feedback, Software Solutions Feedback, AI-Powered Solutions, IT Service Review, Client Feedback Platform',
            url: 'https://www.kalpitatechnologies.com/csat',
            robots: 'noindex, follow'
        }
    },
    // Wildcard must stay last. server.js sends a 404 status for unknown URLs;
    // this route renders the matching not-found page client-side.
    {path: '**', component: NotFoundComponent,
        data: {
            title: 'Page Not Found | Kalpita Technologies',
            description: 'The page you are looking for does not exist. Explore Kalpita Technologies services, blogs, and case studies from our homepage.'
        }
    }
];